import { ReactNode } from "react";

import Tag from "@/components/common/Tag/Tag";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import type { NutrafolAcademyCourse } from "@/types/nutrafolAcademy";

export interface CourseInfoPanelProps {
  course: NutrafolAcademyCourse;
  tagLabel?: string;
  children?: ReactNode;
}

const CourseInfoPanel = ({ course, tagLabel, children }: CourseInfoPanelProps) => (
  <div className="p-4 bg-nova-transparency-white-10 border border-nova-transparency-white-10 rounded-sm">
    {tagLabel ? (
      <Tag
        data={{
          line: tagLabel,
          classes: "bg-nova-base-solid-40 mb-2",
        }}
      />
    ) : null}
    <TextElementNova text={course.title} className="Title-10-Super-Normal text-nova-base-white" />
    <TextElementNova
      text={`Learn from ${course.author}, ${course.authorTitle}`}
      className="Body-10-Dia-Normal text-nova-base-white pt-2"
    />
    {children}
  </div>
);

export default CourseInfoPanel;
